import { useState } from 'react';
import { message } from 'antd';
import { updateWishlist } from '../api/Wishlist';

export const useWishlist = () => {
    const [loading, setLoading] = useState(false);

    /**
     * Hàm xử lý toggle like
     * @param productId ID sản phẩm
     * @param onSuccess Callback chạy khi API thành công (để update UI)
     */
    const handleToggleWishlist = async (productId: number | string, onSuccess?: () => void) => {
        if (loading) return;

        setLoading(true);
        const res = await updateWishlist(productId);
        setLoading(false);

        if (res && res.status) {
            message.success(res.msg || 'Cập nhật thành công!');
            if (onSuccess) {
                onSuccess();
            }
            return true;
        } else {
            return false;
        }
    };

    return {
        handleToggleWishlist,
        loading
    };
};